/* Dasevikin theme JS */
document.addEventListener('DOMContentLoaded', function () {
  /* Tabs (product page) */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    tabs.querySelectorAll('.tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabs.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
        tabs.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = tabs.querySelector('[data-panel="' + btn.dataset.tab + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  });

  /* Product gallery: thumbs + scroll row */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('.gallery-main img');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gal.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (main && thumb.dataset.src) main.src = thumb.dataset.src;
      });
    });

    var track = gal.querySelector('[data-gallery-track]');
    var prev = gal.querySelector('[data-gallery-prev]');
    var next = gal.querySelector('[data-gallery-next]');
    var stepSize = function () {
      var item = track ? track.querySelector('.thumb') : null;
      return item ? item.getBoundingClientRect().width + 10 : 90;
    };
    if (track && prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize() * 2, behavior: 'smooth' }); });
    if (track && next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize() * 2, behavior: 'smooth' }); });
  });

  /* Variant swatches: one row per option, keeps the hidden select in sync */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var select = picker.querySelector('[data-variant-select]');
    if (!select) return;
    var groups = picker.querySelectorAll('[data-option-index]');

    function currentOptions() {
      var values = [];
      groups.forEach(function (g) {
        var active = g.querySelector('.variant-swatch.selected');
        values.push(active ? active.dataset.value : '');
      });
      return values;
    }

    /* Switch the main image to the one attached to the selected variant */
    function showVariantImage() {
      var opt = select.options[select.selectedIndex];
      var imgId = opt ? opt.dataset.imageId : '';
      if (!imgId) return;
      var gal = document.querySelector('[data-gallery]');
      if (!gal) return;
      var thumb = gal.querySelector('[data-gallery-thumb][data-media-id="' + imgId + '"]');
      if (thumb) {
        thumb.click();
        if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    function syncSelect() {
      var wanted = currentOptions();
      var found = null;
      Array.prototype.forEach.call(select.options, function (opt) {
        if (found) return;
        var opts = (opt.dataset.options || '').split('||');
        var match = wanted.every(function (v, i) { return !v || opts[i] === v; });
        if (match && !opt.disabled) found = opt;
      });
      if (found) {
        select.value = found.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        showVariantImage();
      }
    }

    select.addEventListener('change', showVariantImage);

    groups.forEach(function (g) {
      g.querySelectorAll('.variant-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          g.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('selected'); });
          swatch.classList.add('selected');
          syncSelect();
        });
      });
    });
  });

  /* Quantity +/- */
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.qty-box');
      var input = wrap ? wrap.querySelector('input') : null;
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      if (btn.hasAttribute('data-qty-plus')) { val += 1; } else { val = Math.max(min, val - 1); }
      input.value = val;
    });
  });

  /* Carousels */
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-car-track]');
    if (!track) return;
    var step = function () {
      var item = track.querySelector(':scope > *');
      return item ? item.getBoundingClientRect().width + 18 : 300;
    };
    var prev = car.querySelector('[data-car-prev]');
    var next = car.querySelector('[data-car-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  });

  /* Hero slider */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-hero-track]');
    if (!track) return;
    var slides = track.children;
    var n = slides.length;
    if (n < 2) return;
    var i = 0, timer = null;
    var dots = slider.querySelector('[data-hero-dots]');
    var prev = slider.querySelector('[data-hero-prev]');
    var next = slider.querySelector('[data-hero-next]');
    function go(k) {
      i = (k + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      update();
    }
    function update() {
      if (!dots) return;
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('active', k === i); });
    }
    if (dots) {
      for (var k = 0; k < n; k++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          b.addEventListener('click', function () { go(idx); restart(); });
          dots.appendChild(b);
        })(k);
      }
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    function restart() {
      clearInterval(timer);
      var ms = parseInt(slider.dataset.interval, 10) || 6000;
      timer = setInterval(function () { go(i + 1); }, ms);
    }
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', restart);
    update();
    restart();
  });

  /* Navigation: hover on desktop, tap on touch. Hover is handled by CSS. */
  document.querySelectorAll('[data-menu-parent]').forEach(function (parent) {
    var toggle = parent.querySelector('[data-menu-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches || window.innerWidth < 990) {
        e.preventDefault();
        var wasOpen = parent.classList.contains('open');
        document.querySelectorAll('[data-menu-parent].open').forEach(function (p) { p.classList.remove('open'); });
        if (!wasOpen) {
          parent.classList.add('open');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          toggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
    parent.addEventListener('mouseleave', function () {
      parent.classList.remove('open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-menu-parent]')) {
      document.querySelectorAll('[data-menu-parent].open').forEach(function (p) { p.classList.remove('open'); });
    }
  });

  /* Mobile menu toggle (top left hamburger) */
  document.querySelectorAll('.nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('.header-nav');
      if (nav) nav.classList.toggle('mobile-open');
    });
  });

  /* Auto-hide cart count when empty */
  document.querySelectorAll('.cart-count').forEach(function (el) {
    if (parseInt(el.textContent, 10) === 0) el.style.display = 'none';
  });

  /* Sticky nav bar: pin the menu row to the top while scrolling */
  var nav = document.querySelector('.header-nav');
  if (nav) {
    var navTop = nav.offsetTop;
    var stickNav = function () {
      if (window.scrollY > navTop) {
        if (!nav.classList.contains('nav-stuck')) {
          document.body.style.paddingTop = nav.offsetHeight + 'px';
          nav.classList.add('nav-stuck');
        }
      } else if (nav.classList.contains('nav-stuck')) {
        nav.classList.remove('nav-stuck');
        document.body.style.paddingTop = '';
      }
    };
    window.addEventListener('scroll', stickNav, { passive: true });
    window.addEventListener('resize', function () {
      if (!nav.classList.contains('nav-stuck')) {
        navTop = nav.offsetTop;
      } else {
        document.body.style.paddingTop = nav.offsetHeight + 'px';
      }
    });
  }

  /* Back to top button (right side, appears after scrolling down) */
  var topBtn = document.getElementById('BackToTop');
  if (topBtn) {
    var toggleTopBtn = function () {
      topBtn.classList.toggle('show', window.scrollY > 400);
    };
    window.addEventListener('scroll', toggleTopBtn, { passive: true });
    toggleTopBtn();
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});

/* ============ Quick look section ============ */
(function () {
    function initQl(root) {
      if (root.getAttribute('data-ql-init')) return;
      root.setAttribute('data-ql-init', '1');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.ql-poster-slide'));
      var prods = Array.prototype.slice.call(root.querySelectorAll('.ql-products'));
      if (!slides.length) return;
      var idx = 0, timer = null;

      /* 每次都实时读取轮播时间（优先当前产品组自己的设置，编辑器改了立刻生效） */
      function getInterval() {
        var p = prods[idx];
        var v = p ? parseFloat(p.getAttribute('data-interval')) : 0;
        if (!v || v < 1) v = parseFloat(root.getAttribute('data-interval'));
        if (!v || v < 1) v = 4;
        return v * 1000;
      }
      function restartAuto() {
        if (timer) clearInterval(timer);
        timer = setInterval(step, getInterval());
      }
      /* 产品图直接跳变（无滑动动画） */
      function step() {
        var p = prods[idx];
        if (!p) return;
        var imgs = Array.prototype.slice.call(p.querySelectorAll('.ql-img'));
        if (imgs.length < 2) return;
        var cur = (parseInt(p.getAttribute('data-cur') || '0', 10) + 1) % imgs.length;
        p.setAttribute('data-cur', cur);
        imgs.forEach(function (im, k) { im.classList.toggle('active', k === cur); });
      }
      /* 海报与产品组直接切换（无滑动动画） */
      function show(i) {
        idx = ((i % slides.length) + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('active', k === idx); });
        prods.forEach(function (p, k) {
          p.classList.toggle('active', k === idx);
          p.setAttribute('data-cur', '0');
          var imgs = Array.prototype.slice.call(p.querySelectorAll('.ql-img'));
          imgs.forEach(function (im, kk) { im.classList.toggle('active', kk === 0); });
        });
        restartAuto();
      }
      var prev = root.querySelector('[data-ql-prev]');
      var next = root.querySelector('[data-ql-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });

      /* 手机端手指左右滑动切换海报（横向位移大于纵向才生效，避免干扰上下滚动） */
      var vp = root.querySelector('.ql-poster-viewport') || root;
      var tx = 0, ty = 0, swiping = false;
      vp.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        tx = t.clientX; ty = t.clientY; swiping = true;
      }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - tx;
        var dy = t.clientY - ty;
        if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return;
        show(idx + (dx < 0 ? 1 : -1));
      }, { passive: true });

      root._qlShow = show;
      show(0);
    }
    function initAll() {
      document.querySelectorAll('[data-ql]').forEach(initQl);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    /* 编辑器里改动分区设置后重新初始化（读取新的轮播时间） */
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector) e.target.querySelectorAll('[data-ql]').forEach(initQl);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest ? e.target.closest('[data-ql]') : null;
      if (!root) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.ql-poster-slide'));
      var i = slides.indexOf(e.target);
      if (i > -1 && root._qlShow) root._qlShow(i);
    });
  })();
